export default {
    '-': "-",
    actions: "Әрекеттер",
    actions_with_selected: "Таңдалғандармен әрекеттер",
    active: "Іске қосылған",
    add: "Қосу",
    add_attachment: "Тіркемені қосу",
    add_condition: "Шартты қосу",
    afternoon: "Түс",
    all: "Барлығы",
    app_is_in_maintenance_mode: "Қосымшада техникалық жұмыстар жүргізілуде. Біз міндетті түрде жақын арада ораламыз",
    are_you_sure_you_want_to_delete: " Материалды жойғыңыз келе ме?",
    are_you_sure_you_want_to_logout: " Шыққыңыз келе ме?",
    assistant_id: "Көмекші",
    authorization: "Авторласу",
    authorize_in_system: "Жүйеде авторласыңыз",
    azerbaijani: "Әзербайджан",
    balance: "Депозит",
    cancel: "Болдыртпау",
    cancel_verb: "Болдырмау",
    change: "Өзгерту",
    change_password: "Құпия сөзді өзгерту",
    comment: "Түсіндірмелер",
    confirm_deletion: "Жоюды растау?",
    contacts: "Байланыс деректер",
    contains: "Қамтиды",
    continue: "Жалғастыру",
    credit: "Несие",
    currency: "Валюта",
    custom_role_rights_updated: "Рөл құқықтары жаңартылды",
    delete: "Жою",
    dentistry: "Стоматология",
    do_not_save: "Сақтамаңыз",
    does_not_equal: "Тең емес",
    done: "Дайын",
    down: "Төмен",
    edit: "Өңдеу",
    egisz_send_error: "ЕГИСЗ-ге жіберу қатесі",
    egisz_send_success: "ЕГИСЗ-ге сәтті жіберілді",
    email: "Email",
    email_required_for_password_reset: "Осы пайдаланушының құпия сөзін қалпына келтіру үшін оның email мекенжайы көрсетілуі керек",
    end: "Аяқтау",
    english: "Ағылшын",
    enter_username_to_reset_password: "Құпия сөзді қалпына келтіру сілтемесін алу үшін логиниңізді енгізіңіз",
    equals: "Тең",
    error: "Қате",
    error_message: " Бірдеңе қате болды, операция сәтті аяқталмады ",
    evening: "Кеш",
    excel: "Excel",
    exported_patients_to_excel: "Науқастарды Excel бағдарламасына жүктеп салды",
    exported_report_to_excel: "Есепті Excel-ге жүктеп салды",
    fact: "Факт",
    family_account_member_toggled: "Отбасылық шот қатысушысының белсенділігін өзгертті",
    family_account_updated: "Отбасылық шоттың құрамын жаңартты",
    file: "Файл",
    file_does_not_exist: "Файл табылмады",
    file_size_is_too_big: "Файлдың өлшемі тымм үлкен",
    filled: "Толтырылды",
    filled_not_signed: "Толтырылды / қол қойылмады",
    filter: "Сүзгі",
    finish: "Аяқтау",
    finishing_operation: "Операцияны аяқтау",
    forgot_password: "құпия сөзді ұмыттыңыз ба?",
    from_to: "{from} бастап {to} дейін",
    general_cost: "Жалпы құны",
    general_medicine: "Жалпы медицина",
    general_slogan: "Заманауи клиниканы басқаруға арналған бұлттық шешім",
    hide: "Жасыру",
    hide2: "Жасыру",
    home: "Негізгі",
    image: "Сурет",
    import: "Импорт",
    in_interval: "Аралықта",
    input_field: "Мәтінді енгізуге арналған өріс",
    integration: "Интеграция",
    invalid_reset_link: "Бұл құпия сөзді қалпына келтіру сілтемесі жарамсыз немесе мерзімі өтіп кеткен",
    kazakh: "Қазақ",
    kyrgyz: "Қырғыз",
    KZT: "KZT",
    language: "Тіл",
    less: "Кемінде",
    links: "Сілтемелер",
    load_more: "Тағы жүктеу",
    logged: "Рұқсат етілген",
    logged_out: "Жүйеден шықты",
    login: "Логин",
    login_disclaimer: "DENTIST PLUS жүйесіне кіруді жалғастыра отырып, сіз өз есептік жазбаңызды пайдаланып жатқаныңызды растайсыз және есептік деректеріңізді пайдалану арқылы жасалған әрекеттерге жауапкершілікті өз мойныңызға аласыз. Есептік деректерді үшінші тұлғаларға беруге тыйым салынады.",
    login_failed: "Жүйеге кіру сәтсіз аяқталды",
    login_locked_out: "Кіру бұғатталды (көп әрекет)",
    login_or_pass_incorrect: "Логин және / немесе құпия сөз қате",
    logout: "Шығу",
    main: "Негізгі",
    message: "Хабарлама",
    module_unavailable: "Модуль қолжетімсіз",
    months: "Айлар",
    more: "Артығырақ",
    more_2: "Көбірек",
    morning: "Таңертең",
    must_change_password_notice: "Жалғастыру үшін құпия сөзді өзгерту қажет",
    name: "Аты",
    new_password: "Жаңа құпия сөз",
    no: "Жоқ",
    no_data_available: "Деректер әзірге жоқ",
    nonactive: "Белсенді емес",
    not_enough_rights_for_this_operation: " Осы әрекет үшін құқықтар жеткіліксіз ",
    not_filled: "Толтырылмаған",
    nothing_found: "Ештеңе табылмады",
    old_password: "Ескі құпия сөз",
    on_page: "Парақшада",
    page_not_found: "Парақша табылмады",
    password: "Құпия сөз",
    password_changed: "Құпия сөз өзгертілді",
    password_confirm: "Құпия сөзді растау",
    password_reset_link_sent: "Егер осы логинмен тіркелгі болса, оның электрондық поштасына құпия сөзді қалпына келтіру сілтемесі жіберілді",
    password_reset_failed: "Құпия сөзді қалпына келтіру сәтсіз аяқталды",
    password_reset_requested: "Құпия сөзді қалпына келтіруді сұрады",
    password_reset_succeeded: "Құпия сөзді сәтті қалпына келтірді",
    passwords_do_not_match: "Құпия сөздер сәйкес келмейді",
    patient_search: "Пациентті іздеу",
    patient_tags_updated: "Науқастың белгілерін жаңартты",
    payment_expires_at: "Төлем мерзімі аяқталуда",
    phone: "Телефон",
    photo: "Фото",
    price: "Баға",
    print_noun: "Басып шығару",
    professional: "Кәсіби",
    profile: "Профиль",
    program: "Бағдарлама",
    refresh: "Жаңарту",
    registration: "Тіркеу",
    requirements: "Талаптар",
    reset: "Қалпына келтіру",
    reset_password: "Құпия сөзді қалпына келтіру",
    reset_password_email_note: "Пайдаланушыға жаңа құпия сөз орнату үшін электрондық поштасына сілтеме жіберіледі",
    reset_success: "Қалпына келтіру хаты Сіздің E-mail жіберілді",
    role: "Рөл",
    russian: "Орыс тілі",
    save: "Сақтау",
    search: "Іздеу",
    select: "Таңдау",
    send_reset_link: "Сілтемені жіберу",
    sent: "Жіберілді",
    session_revoked: "Сессияны кері қайтарды",
    sessions_revoked: "Барлық басқа сессияларды кері қайтарды",
    settings: "Реттеу",
    show: "Көрсету",
    show_full: "Толық көрсету",
    signin: "Кіру",
    slogan: " Заманауи стоматологияны басқаруға арналған бұлтты шешім ",
    sorting: "Сұрыптау",
    staff_rights_updated: "Қызметкер құқықтары жаңартылды",
    staff_role_updated: "Қызметкер рөлі жаңартылды",
    start: "Бастау",
    start_noun: "Басталуы",
    status: "Статус",
    subscription_sum: "Жазылым сомасы",
    success_message: "Операция сәтті өтті",
    sum: "сома",
    system: "Жүйелі",
    table_search: "Кесте бойынша іздеу",
    tech_specialist: "Техникалық маман",
    text: "Мәтін",
    there_are_unsaved_changes: "Сақталмаған өзгертулер бар",
    this_module_is_not_in_tariff: "Бұл модуль Free тарифіне кірмейді, сізге Standard немесе Premium қосылу керек және сіз Dentist Plus бағдарламасының көптеген функционалдарына қол жеткізе аласыз.",
    title: "Атауы",
    to_top: "Жоғарыға",
    today: "Бүгін",
    total: "Барлығы",
    translation: "Аудару",
    unknown: "Белгісіз",
    upload: "Жүктеу",
    web: "Web",
    who_has_access: "Кімге қолжетімді",
    wrong_file_format: "Жарамсыз файл пішімі",
    yes: "Иә"
}
